import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/api";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email);
      toast.success("Subscribed! Welcome to GrabNChat.");
      setEmail("");
    } catch (err) {
      toast.error(err?.message || "Could not subscribe. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex gap-2" data-testid="newsletter-form">
      <Input
        type="email"
        required
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="bg-white/5 border-white/10 text-white placeholder:text-slate-500"
        data-testid="newsletter-email-input"
      />
      <Button type="submit" disabled={loading} className="bg-[#25D366] hover:bg-[#1DA851] text-white rounded-md whitespace-nowrap" data-testid="newsletter-submit-btn">
        {loading ? "..." : "Subscribe"}
      </Button>
    </form>
  );
}
